import React, { useState } from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import './Accordion.css';

const AccordionItem = ({ title, subtitle, badge, children, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
            <button
                className="accordion-header"
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
            >
                <div className="accordion-header-content">
                    <span className="accordion-icon">
                        {isOpen ? <FiChevronDown size={18} /> : <FiChevronRight size={18} />}
                    </span>
                    <div className="accordion-title-group">
                        <span className="accordion-title">{title}</span>
                        {subtitle && <span className="accordion-subtitle">{subtitle}</span>}
                    </div>
                </div>
                {badge !== undefined && (
                    <span className="accordion-badge">{badge}</span>
                )}
            </button>
            <div className={`accordion-content ${isOpen ? 'expanded' : ''}`}>
                <div className="accordion-content-inner">
                    {children}
                </div>
            </div>
        </div>
    );
};

const Accordion = ({ children, className = '' }) => {
    return (
        <div className={`accordion ${className}`}>
            {children}
        </div>
    );
};

Accordion.Item = AccordionItem;

export default Accordion;
